import CV from "../../Assets/Images/CV.pdf"

const CTA = () => {
  return (
    <div>
        <div className='mt-10 flex gap-5 justify-center'>
            <a href={CV} download className='btn'>Download CV</a>
            <a href='#contact' className='btn btn-primary'>Contact</a>
        </div>
    </div>
  )
}

export default CTA
